var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('b-card',{staticClass:"lb-dashboard-panel-machines card-white card-no-gutters shadow",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"d-flex justify-content-start align-items-center"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }